import { useEffect, useState } from 'react';
import { Root } from 'routes/ToS';
import { getTiflePolicies } from 'services/api';

const PrivacyPolicy = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState('');

  useEffect(() => {
    getTiflePolicies({ name: 'Tifle Privacy Policy' }).then((res: any) => {
      if (res) {
        setPrivacyPolicy(res.Tifle_Policies_Desc);
      }
    });
  }, []);

  return (
    <Root>
      <div className="header">
        <h2>Privacy Policy</h2>
      </div>
      <div className="wrapper">
        <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: privacyPolicy
              .replaceAll('\n', '<br />')
              .replaceAll('”', '"'),
          }}
        />
      </div>
    </Root>
  );
};

export default PrivacyPolicy;
